/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  isReload: false,
  barChartData: [],
  pieChartData: [],
};

const issuechartReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'addcustomer':
    case 'customereditdata':
      return {
        ...state,
        isReload: true,
      };
    case 'validmail':
      return {
        ...state,
        isEmailValid: action.value,
      };
    case 'BAR_CHART_DATA':
      return {
        ...state,
        barChartData: action.value,
      };
    case 'PIE_CHART_DATA':
      return {
        ...state,
        pieChartData: action.value,
      };
    default:
      return state;
  }
};

export default issuechartReducer;
